import React from 'react';
import { Link } from 'react-router-dom';
import {
  DesktopOutlined,
  BarcodeOutlined,
  ShopOutlined,
  SafetyCertificateOutlined,
  DollarOutlined,
  EyeOutlined,
  ArrowRightOutlined
} from '@ant-design/icons';
// Thème citron / noir / blanc de la page (classes préfixées "ab-")
import './About.css';

// Les trois applications de la plateforme (toutes présentes dans le projet)
const APPLICATIONS = [
  {
    icon: <DesktopOutlined />,
    titre: 'Backoffice',
    texte: 'Commandes, clients, produits, livraisons, dépenses, analyses et assistant IA, accessibles depuis un seul tableau de bord.'
  },
  {
    icon: <BarcodeOutlined />,
    titre: 'Caisse (POS)',
    texte: 'Une application de caisse pour vos caissiers : connexion par code PIN, lecture code-barres, ventes en attente et reçus sur WhatsApp.'
  },
  {
    icon: <ShopOutlined />,
    titre: 'Vitrine en ligne',
    texte: 'Un site par boutique, sur son sous-domaine, avec catalogue et tunnel de commande relié à votre backoffice.'
  }
];

// Principes de conception, vérifiables dans l'application
const PRINCIPES = [
  {
    icon: <DollarOutlined />,
    titre: 'Pensé pour le marché local',
    texte: 'Montants en franc CFA, livraison par zones et jours, paiement par mobile money à la caisse.'
  },
  {
    icon: <SafetyCertificateOutlined />,
    titre: 'Données séparées par boutique',
    texte: 'Chaque boutique dispose de ses propres données, paramètres et intégrations, avec un accès réservé à son équipe.'
  },
  {
    icon: <EyeOutlined />,
    titre: 'Offres et quotas transparents',
    texte: 'Cinq offres aux quotas publiés, du plan gratuit de 14 jours à l\'offre sans limite sur les quotas courants.'
  }
];

// Chiffres issus de la configuration réelle des offres
const CHIFFRES = [
  { valeur: '3', libelle: 'applications : backoffice, caisse et vitrine' },
  { valeur: '5', libelle: 'offres, dont un essai gratuit' },
  { valeur: '14 jours', libelle: 'd\'essai sans engagement' },
  { valeur: '4', libelle: 'fournisseurs WhatsApp API pris en charge' }
];

const About = () => {
  return (
    <div className="ab-page">
      {/* Hero */}
      <section className="ab-hero">
        <span className="ab-pill">À propos</span>
        <h1>Mercuri Shop, la plateforme des <span className="ab-mark">commerçants WhatsApp</span></h1>
        <p>
          Mercuri Shop aide les commerçants de Côte d'Ivoire à gérer leurs commandes, leurs livraisons,
          leur stock et leur boutique en ligne depuis un seul outil, avec WhatsApp au centre.
        </p>
      </section>

      {/* Mission */}
      <section className="ab-section ab-mission">
        <h2>Notre mission</h2>
        <p>
          Beaucoup de commerçants vendent sur WhatsApp, mais gèrent leurs commandes, leurs livreurs et
          leur stock avec des outils séparés. Mercuri Shop réunit ces tâches : vous recevez vos commandes,
          assignez vos livreurs, suivez vos stocks et vos dépenses, et gardez le contact avec vos clients sur WhatsApp.
        </p>
      </section>

      {/* Applications */}
      <section className="ab-section">
        <h2>Ce que nous proposons</h2>
        <div className="ab-grid">
          {APPLICATIONS.map((app) => (
            <article key={app.titre} className="ab-card">
              <span className="ab-icon">{app.icon}</span>
              <h3>{app.titre}</h3>
              <p>{app.texte}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Chiffres */}
      <section className="ab-stats">
        <div className="ab-stats-grid">
          {CHIFFRES.map((chiffre) => (
            <div key={chiffre.libelle}>
              <strong>{chiffre.valeur}</strong>
              <span>{chiffre.libelle}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Principes */}
      <section className="ab-section">
        <h2>Nos principes</h2>
        <div className="ab-grid">
          {PRINCIPES.map((principe) => (
            <article key={principe.titre} className="ab-card">
              <span className="ab-icon">{principe.icon}</span>
              <h3>{principe.titre}</h3>
              <p>{principe.texte}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Appel à l'action */}
      <section className="ab-cta">
        <h2>Une question sur Mercuri Shop ?</h2>
        <p>Basés à Abidjan, nous répondons à vos questions et organisons des démonstrations.</p>
        <div>
          <Link to="/register" className="ab-btn ab-btn-accent">Essai gratuit 14 jours <ArrowRightOutlined /></Link>
          <Link to="/contact" className="ab-btn ab-btn-light">Nous contacter</Link>
        </div>
      </section>
    </div>
  );
};

export default About;
